import type { ReducerUsageData, UsageState } from '../types';

export const INIT_STATE: UsageState = {
  usageData: {} as ReducerUsageData,
  countData: [],
};
